<ng-container>
  <c-container  [fluid]="true">
    <c-header-nav class="d-flex me-auto">
    </c-header-nav>
    <p-button
      icon="pi pi-bell"
      [text]="true"
      class="announcements-button"
      styleClass="bg-transparent shadow-none avatar-md"
      badge="{{ unseenAnnouncementsCount > 0 ? unseenAnnouncementsCount.toString() : null }}"
      badgeClass="p-badge-danger"
      pTooltip="What's New" 
      tooltipPosition="bottom"
      (onClick)="openAnnouncementsDialog()">
    </p-button>
    <p-button
      icon="pi pi-send"
      [text]="true"
      class="chat-button"
      styleClass="bg-transparent shadow-none avatar-md"
      badge="{{ hucuUnreadCount > 0 ? hucuUnreadCount.toString() : null }}"
      badgeClass="p-badge-danger"
      pTooltip="Chat"
      tooltipPosition="bottom"
      (onClick)="onToggleMessagesSidebar()">
    </p-button>
    <a [href]="portalSupportUrl" target="_blank" class="p-button p-button-icon-only p-button-link text-white avatar-md support-icon-link border-0" pTooltip="Portal Support" tooltipPosition="bottom" >
      <img src="/assets/img/portal/user-headset.svg" alt="Portal Support" class="support-icon" />
    </a>
    <c-header-nav class="p-2 ps-0">
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>

  </c-container>
</ng-container>

<app-announcements-dialog
  [(visible)]="showAnnouncementsDialog"
  [announcements]="unseenAnnouncements"
  (visibleChange)="onAnnouncementsDialogClose()"
  (acknowledge)="onAnnouncementsAcknowledged($event)">
</app-announcements-dialog>

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button
      cButton
      color=""
      [caret]="false"
      cDropdownToggle
      class="py-0 flex align-items-baseline gap-1"
    >
      <div class="avatar avatar-md text-white" [style]="{ 'background-color': generateAvatarColor(), 'color': '#ffffff'}" >{{getInitials()}}</div>
      <div class="font-semibold text-base">  {{ this.currentUser.name }} </div>
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <a (click)=logout()  cDropdownItem>
          <i class="fa-solid fa-arrow-right-from-bracket w-1rem me-2"></i>
          Logout
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>
